var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "license-information" }, [
    _c("fieldset", { staticClass: "info-group" }, [
      _c("legend", [_vm._v(_vm._s(_vm.$t("kyc.licenseInformation")))]),
    ]),
    _c(
      "fieldset",
      { attrs: { disabled: _vm.kycStatus === "submitted" ? true : false } },
      [
        _c("div", { staticClass: "info-group" }, [
          _c(
            "div",
            {
              staticClass: "form-group with-icon-right",
              class: {
                "has-error": _vm.listedCompanyStatus,
                valid: _vm.listedCompanyStatus,
              },
            },
            [
              _c(
                "div",
                { staticClass: "input-group" },
                [
                  _c("vuestic-kyc-select", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    ref: "myInput1",
                    attrs: {
                      name: "listedCompany",
                      "data-vv-as": "Listed Company",
                      required: "",
                      label: _vm.$t("kyc.isAListedCompany"),
                      "option-key": "value",
                      options: _vm.licenseOptions,
                      disabled: _vm.kycStatus === "submitted" ? true : false,
                    },
                    on: { input: _vm.forbiddenInput1 },
                    model: {
                      value: _vm.licenseInformation.listedCompany,
                      callback: function ($$v) {
                        _vm.$set(_vm.licenseInformation, "listedCompany", $$v)
                      },
                      expression: "licenseInformation.listedCompany",
                    },
                  }),
                  _c("i", {
                    staticClass:
                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                  }),
                  _c("i", { staticClass: "fa icon-right input-icon" }),
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.listedCompanyStatus,
                          expression: "listedCompanyStatus",
                        },
                      ],
                      staticClass: "help text-danger",
                    },
                    [_vm._v(_vm._s(_vm.errors.first("listedCompany")))]
                  ),
                ],
                1
              ),
            ]
          ),
          _c("div", { staticClass: "info-group-space" }),
          _c(
            "div",
            {
              staticClass: "form-group with-icon-right",
              class: {
                "has-error": _vm.aLicenseStatus,
                valid: _vm.aLicenseStatus,
              },
            },
            [
              _c(
                "div",
                { staticClass: "input-group" },
                [
                  _c("vuestic-kyc-select", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    ref: "myInput2",
                    attrs: {
                      name: "aLicense",
                      "data-vv-as": "A License",
                      required: "",
                      label: _vm.$t("kyc.heldALicense"),
                      "option-key": "value",
                      options: _vm.licenseOptions,
                      disabled: _vm.kycStatus === "submitted" ? true : false,
                    },
                    on: { input: _vm.forbiddenInput2 },
                    model: {
                      value: _vm.licenseInformation.aLicense,
                      callback: function ($$v) {
                        _vm.$set(_vm.licenseInformation, "aLicense", $$v)
                      },
                      expression: "licenseInformation.aLicense",
                    },
                  }),
                  _c("i", {
                    staticClass:
                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                  }),
                  _c("i", { staticClass: "fa icon-right input-icon" }),
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.aLicenseStatus,
                          expression: "aLicenseStatus",
                        },
                      ],
                      staticClass: "help text-danger",
                    },
                    [_vm._v(_vm._s(_vm.errors.first("aLicense")))]
                  ),
                ],
                1
              ),
            ]
          ),
        ]),
        _vm.licenseInformation.aLicense.id === 1
          ? _c("div", { staticClass: "info-group" }, [
              _c(
                "div",
                {
                  staticClass: "form-group with-icon-right",
                  class: {
                    "has-error": _vm.licenseListStatus,
                    valid: _vm.licenseListStatus,
                  },
                },
                [
                  _c(
                    "label",
                    {
                      staticClass:
                        "control-label upload-label app-logo-label-kyc",
                      attrs: { for: "license" },
                    },
                    [_vm._v("License：")]
                  ),
                  _c(
                    "div",
                    { staticClass: "app-logo-wrapper-kyc" },
                    [
                      _c("vuestic-file-upload-kyc", {
                        ref: "fieldInput",
                        attrs: {
                          id: "license",
                          type: "list",
                          disabled:
                            _vm.kycStatus === "submitted" ? true : false,
                        },
                        on: {
                          input: _vm.uploadFile,
                          removeFile: _vm.removeFile,
                        },
                        model: {
                          value: _vm.licenseInformation.licenseList,
                          callback: function ($$v) {
                            _vm.$set(_vm.licenseInformation, "licenseList", $$v)
                          },
                          expression: "licenseInformation.licenseList",
                        },
                      }),
                      _c(
                        "small",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.licenseListStatus,
                              expression: "licenseListStatus",
                            },
                          ],
                          staticClass: "help text-danger",
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("kyc.theLicenseFieldIsRequired"))
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }